import { IKanbanCard } from '../../types/layout/kanban';
import {
    TMoveKanbanCardAction, TMoveKanbanCardToColumnAction, TSetKanbanCardsAction, TSetKanbanDraggingCardAction,
} from '../../types/redux/kanban';

export const SET_KANBAN_CARDS = 'SET_KANBAN_CARDS';
export const MOVE_KANBAN_CARD = 'MOVE_KANBAN_CARD';
export const MOVE_KANBAN_CARD_TO_COLUMN = 'MOVE_KANBAN_CARD_TO_COLUMN';
export const SET_KANBAN_DRAGGING_CARD = 'SET_KANBAN_DRAGGING_CARD';

export const setKanbanCards = (cards: IKanbanCard[]): TSetKanbanCardsAction => ({
    type: SET_KANBAN_CARDS,
    pyload: {
        cards,
    },
});

export const moveKanbanCard = (targetId: string, replaceId: string, bottom: boolean): TMoveKanbanCardAction => ({
    type: MOVE_KANBAN_CARD,
    payload: {
        bottom,
        replaceId,
        targetId,
    },
});

export const moveKanbanCardToColumn = (card: string, column: string): TMoveKanbanCardToColumnAction => ({
    type: MOVE_KANBAN_CARD_TO_COLUMN,
    payload: {
        card,
        column,
    },
});

export const setKanbanDraggingCard = (card: string, dragging: boolean): TSetKanbanDraggingCardAction => ({
    type: SET_KANBAN_DRAGGING_CARD,
    pyload: {
        card,
        dragging,
    },
});
